<template>
  <form
    novalidate
    method="post"
    @submit.prevent="onSubmit"
  >
    <slot :errors="errors" />
  </form>
</template>

<script>
export default {
  name: 'ControlForm',
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    // source data used inside form
    // attention: we use vee-validate to valdate data
    // but not assign validate directive into form fields
    // because we not control fields inside this component
    // We use programatic of vee-validate to handle source data
    source: { type: Object, default: () => null },
    // rule to validate source. if not provided then skip validate
    rules: { type: Object, default: () => null },
    // setup alias name
    aliases: { type: Object, default: () => ({}) },
  },
  mounted() {
    // skip if not provided rules
    if (!this.rules) return true
    // setup validate
    const self = this
    // because at the time [mounted] hook of this component triggered
    // all child component maybe not mounted yet
    // this cause make refs points failed because it not exists
    // we use set timeout to set a trick waiting
    // some validate rule like [confirmed] require refenrece to extra
    // fields though [refs]
    // - listen change from rules to update / remap
    setTimeout(() => {
      self.$watch(
        'rules',
        rules => {
          const validateKeys = Object.keys(rules)
          validateKeys.map(key =>
            self.$validator.attach({
              vm: self.$parent,
              name: key,
              rules: self.rules[key],
              getter: () => self.source[key],
              listen: true,
              alias: self.aliases[key] || undefined,
              el: self.$parent.$el || self.$el
            }),
          )
        },
        { immediate: true, deep: true },
      )
    }, 0)
  },
  methods: {
    // save init data source into cache
    syncDefault() {
      this.$options.def = JSON.parse(JSON.stringify(this.source))
    },
    // reset form to init data source
    reset() {
      this.$emit('reset', JSON.parse(JSON.stringify(this.$options.def)))
    },
    // submit from
    onSubmit() {
      const self = this
      const copySource = JSON.parse(JSON.stringify(self.source))
      // if not need validate we just pass value
      if (!self.rules) {
        self.$emit('submit', copySource)
      }
      // validate before use
      else {
        self.$validator.validate().then(passed => {
          if (passed) self.$emit('submit', copySource)
          else self.$emit('invalidate', self.$validator.errors)
        })

        // set watch to auto validate later
        self.$watch('source', source => self.$validator.validate(), {
          deep: true,
        })
      }
      // make sure form not submit to anywhere
      return false
    },
  },
}
</script>

